module.exports = __webpack_public_path__ + "media/images/sports_coaching/main_image1-d708f9d4fc845f6265cb2927366052a4.jpg";